/*
 *
 *   reducer
 *
 */
import { produce } from "immer";

import {
  LOAD_DYNAMIC_IMAGES_LIST_SUCCESS,
  LOAD_DYNAMIC_IMAGES_LIST_ERROR,
  LOAD_BEST_SELLING_DETAILS_IMAGES_SUCCESS,
  LOAD_BEST_SELLING_DETAILS_IMAGES_ERROR,
  LOAD_DYNAMIC_IMAGES_LIST_RECORDS_META_DATA_SUCCESS,
  LOAD_DYNAMIC_IMAGES_LIST_RECORDS_META_DATA_ERROR,
  CREATE_PAYMENT_IN_DETAILS_SUCCESS,
  CREATE_PAYMENT_IN_DETAILS_ERROR,
  UPDATE_PAYMENT_IN_DETAILS_SUCCESS,
  UPDATE_PAYMENT_IN_DETAILS_ERROR,
  DELETE_PAYMENT_IN_DETAILS_SUCCESS,
  DELETE_PAYMENT_IN_DETAILS_ERROR,
  LOAD_DEALS_LIST_SUCCESS,
  LOAD_DEALS_LIST_ERROR,
  LOAD_HOLIDAYS_LIST_SUCCESS,
  LOAD_HOLIDAYS_LIST_ERROR,
  LOAD_TESTIMONIAL_LIST_SUCCESS,
  LOAD_TESTIMONIAL_LIST_ERROR,
  LOAD_DESTINATION_LIST_SUCCESS,
  LOAD_DESTINATION_LIST_ERROR,
  LOAD_PACKAGES_CATEGORY_LIST_SUCCESS,
  LOAD_PACKAGES_CATEGORY_LIST_ERROR,
} from "./constants";

const initialState = {
  dynamic_images_list: [],
  destination_list: [],
  package_category_list: [],
  best_selling_details: [],
  deals_list: [],
  holidays_list: [],
  testimonial_list: [],
  record: {},
  records: {},
  recordsMetaData: {},
  loading: false,
  error: false,
  success: false,
  lastUpdate: null,
};

const Reducer = (
  state = initialState,
  {
    type,
    destination_list,
    dynamic_images_list,
    package_category_list,
    deals_list,
    holidays_list,
    testimonial_list,
    best_selling_details,
    record,
    recordsMetaData = {},
    error,
    success,
  }
) => {
  return produce(state, (draft) => {
    switch (type) {
      // case LOAD_RECORDS_VALID_CACHE:
      //   draft.loading = false;
      //   draft.error = false;
      //   draft.success = false;
      //   break;
      case LOAD_DYNAMIC_IMAGES_LIST_SUCCESS:
        draft.dynamic_images_list = dynamic_images_list;
        draft.loading = false;
        draft.error = false;
        draft.success = false;
        break;
      case LOAD_DESTINATION_LIST_SUCCESS:
        draft.destination_list = destination_list;
        draft.loading = false;
        draft.error = false;
        draft.success = false;
        break;
      case LOAD_PACKAGES_CATEGORY_LIST_SUCCESS:
        draft.package_category_list = package_category_list;
        draft.loading = false;
        draft.error = false;
        draft.success = false;
        break;
      case LOAD_BEST_SELLING_DETAILS_IMAGES_SUCCESS:
        draft.best_selling_details = best_selling_details;
        draft.loading = false;
        draft.error = false;
        draft.success = false;
        break;
      case LOAD_DEALS_LIST_SUCCESS:
        draft.deals_list = deals_list;
        draft.loading = false;
        draft.error = false;
        draft.success = false;
        break;
      case LOAD_HOLIDAYS_LIST_SUCCESS:
        draft.holidays_list = holidays_list;
        draft.loading = false;
        draft.error = false;
        draft.success = false;
        break;
      case LOAD_TESTIMONIAL_LIST_SUCCESS:
        draft.testimonial_list = testimonial_list;
        draft.loading = false;
        draft.error = false;
        draft.success = false;
        break;
      case CREATE_PAYMENT_IN_DETAILS_SUCCESS:
        draft.record = [record].concat(state.record);
        draft.loading = false;
        draft.error = false;
        draft.success = success;
        break;
      case UPDATE_PAYMENT_IN_DETAILS_SUCCESS:
        draft.record = [record].concat(state.record);
        draft.error = false;
        draft.success = success;
        break;
      case DELETE_PAYMENT_IN_DETAILS_SUCCESS:
        draft.record = record;
        draft.error = false;
        draft.success = success;
        break;

      case LOAD_DYNAMIC_IMAGES_LIST_RECORDS_META_DATA_SUCCESS:
        draft.recordsMetaData = recordsMetaData;
        draft.error = false;
        draft.success = success;
        break;

      case LOAD_DYNAMIC_IMAGES_LIST_ERROR:
      case CREATE_PAYMENT_IN_DETAILS_ERROR:
      case UPDATE_PAYMENT_IN_DETAILS_ERROR:
      case DELETE_PAYMENT_IN_DETAILS_ERROR:
      case LOAD_DEALS_LIST_ERROR:
      case LOAD_HOLIDAYS_LIST_ERROR:
      case LOAD_TESTIMONIAL_LIST_ERROR:
      case LOAD_BEST_SELLING_DETAILS_IMAGES_ERROR:
      case LOAD_DESTINATION_LIST_ERROR:
      case LOAD_PACKAGES_CATEGORY_LIST_ERROR:
        draft.loading = false;
        draft.error = error;
        draft.success = false;
        break;

      case LOAD_DYNAMIC_IMAGES_LIST_RECORDS_META_DATA_ERROR:
        draft.error = error;
        draft.success = false;
        break;
      default:
        return state;
    }
  });
};

export default Reducer;
